import { FunctionComponent } from "react";

import SignaturePad from "../../../components/signature-pad";
import CheckBox from "../../../components/check-box";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import { ConfirmTransferScreenProps } from "../useConfirmTransfer";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import Footer from "../../../components/footer";
import Spacing from "../../../layout/spacing";

import { UNEXPECTED_ERROR_MESSAGE } from "../../../typings";
import { BodyMediumRegular, TitleLarge } from "../../../components/font";
import { Button, tokens } from "@manifesthhqinc/ui-library";
import LegalDisclaimer from "../../../components/disclaimer";
import HeadingContainer from "../../../layout/heading-container";

const InitiateTransfer: FunctionComponent<ConfirmTransferScreenProps> = (props: ConfirmTransferScreenProps) => {
  const {
    setSignatureDataURL,
    transferDetails,
    toggleTermsAgreement,
    hasTermsAgreed,
    onClickContinue,
    setShowError,
    isInitiatingTransfer,
    isFutureMoney,
    userDetails,
    validation,
  } = props;

  if (!transferDetails.destinationAccount || transferDetails.transferId === -1) {
    setShowError(UNEXPECTED_ERROR_MESSAGE);
    throw Error(UNEXPECTED_ERROR_MESSAGE);
  }

  return (
    <TransitionWrapper>
      <ScrollableContainer name="confirm-transfer-screen-initiateTransfer">
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <TitleLarge>Lastly, sign to authorize your transfer</TitleLarge>
          </HeadingContainer>
          <p>Your signature</p>
          <Spacing vertical="8" />
          <SignaturePad updateSignatureDataURL={setSignatureDataURL} errorText={validation?.signature} />
          <Spacing vertical="20" />
          <LegalDisclaimer
            isFuturemoney={isFutureMoney}
            fullName={`${userDetails.firstName} ${userDetails.lastName}`}
          />
          {isFutureMoney ? (
            <CheckBox
              onToggleCheckbox={toggleTermsAgreement}
              name="checkbox-terms-agreement"
              isChecked={hasTermsAgreed}
              label={
                <>
                  {" "}
                  By checking the box, I agree to <strong>Manifest</strong>'s terms above, <strong>FutureMoney</strong>
                  's{" "}
                  <a
                    href="https://legal.futuremoney.co/FutureMoney+RIA+-+Investment+Management+Agreement.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Terms of Service
                  </a>{" "}
                  and{" "}
                  <a
                    href="https://legal.futuremoney.co/FutureMoney+Privacy+Notice.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Privacy Policy
                  </a>
                  , as well as the agreements with <strong>FutureMoney RIA</strong>, <strong>LLC</strong>, and{" "}
                  <strong>Altruist Financial LLC</strong>, as outlined above.
                </>
              }
            />
          ) : (
            <CheckBox
              error={!!validation?.terms}
              onToggleCheckbox={toggleTermsAgreement}
              name="checkbox-terms-agreement"
              isChecked={hasTermsAgreed}
              label="By checking the box, I agree to the terms above."
            />
          )}
          {validation?.terms && (
            <BodyMediumRegular $color={tokens.color.text.error}>{validation.terms}</BodyMediumRegular>
          )}
          <Spacing vertical="40" />

          <p style={{ textAlign: "center" }}>Next up, Manifest will run 25+ checks before initiating your transfer.</p>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button name="continue" onClick={onClickContinue} isLoading={isInitiatingTransfer} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default InitiateTransfer;
